export const loadLottieComponent = async () => {
    const lottie = await import('lottie-react');

    return lottie.default;
};
